export enum TYPE_EDPEX_PROJECT_TYPE {
  EDPEX_STRATEGY = "EDPEX_STRATEGY", // งานยุทธศาสตร์
  EDPEX_NORMAL = "EDPEX_NORMAL", // งานพื้นฐาน/งานประจำ/งานตามภารกิจ
}

export enum TYPE_EDPEX_PROJECT_TYPE_ONGOING {
  NEW = "NEW", // โครงการใหม่
  ON_GOING = "ON_GOING", // โครงการต่อเนื่อง
}

export enum UNIT_MEASUREMENT_OF_INDICATORS {
  LEVEL = "LEVEL", // หน่วยวัดระดับ
  QUANTITY = "QUANTITY", // หน่วยวัดจำนวน
  SCORE = "SCORE", // หน่วยวัดคะแนน
  PERCENT = "PERCENT", // หน่วยวัดเปอร์เซ็นต์
  RATIO_PERCENT = "RATIO_PERCENT", // หน่วยวัดร้อยละ
  PROPORTION = "PROPORTION", // หน่วยวัดสัดส่วน
}

export enum TYPE_EDPEX_PROJECT_BUDGET_TYPE {
  NORMAL = "NORMAL", // งบตามโครงการ
  EXTRA = "EXTRA", // งบเพิ่มเติม
}

export enum EDPEX_PROJECT_RESPONSIBLE_TYPE {
  PRIMARY = "PRIMARY", // ผู้รับผิดชอบหลัก
  SECONDARY = "SECONDARY", // ผู้รับผิดชอบร่วม
}

export enum EDPEX_PROJECT_STATUS {
  DRAFT = 'DRAFT', // ร่าง
  PENDING_PROCESS = 'PENDING_PROCESS', // รอดำเนินการ
  PROCESS = 'PROCESS', // กำลังดำเนินการ
  OVERDUE = 'OVERDUE', // เกินกำหนดระยะเวลา
  COMPLETED = 'COMPLETED', // ดำเนินการเสร็จสิ้น
}
// responsible_director
export enum EDPEX_PROJECT_USER_RESPONSIBLE {
  ADMIN = 'รองบริหาร',
  RESEARCH_AND_ACADEMIC = 'รองวิจัยและวิชาการ'
}


export enum EDPEX_PROJECT_DIVISION_RESPONSIBLE {
  ACADEMIC = 'วิชาการ',
  ADMINISTRATIVE = 'บริหาร'
}


export enum EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE {
  ACADEMIC_OFFICE = 'สำนักงานวิชาการ',
  COLLEGE_OFFICE = 'สำนักงานวิทยาลัย'
}